import { USER_UUID } from 'global_constants';
import { v4 as uuidv4 } from 'uuid';

export const getUserSessionUUID = () => {
  let uuid = localStorage.getItem(USER_UUID);
  if (!uuid) {
    uuid = uuidv4();
    localStorage.setItem(USER_UUID, uuid);
  }
  return uuid;
};

export const isProfileEventAdded = (uuid, key) => {
  let isEvent = sessionStorage.getItem(`${uuid}-${key}`);
  return !!isEvent;
};

export const saveProfileEvent = (uuid, key) => {
  sessionStorage.setItem(`${uuid}-${key}`, true);
};
